// @ts-nocheck
// tslint:disable
/**
 * PalmApp Server Web API v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { CompanyThemeSettingDto } from './company-theme-setting-dto';

// tslint:disable
import { APIModel, APIModelOptions, AttributeMapItem } from "../base";

export class CompanyThemeViewDto extends APIModel {
    /**
    * Theme identifier
    */
    id: number;
    /**
    * Theme version
    */
    version: string;
    /**
    * List of theme settings. Can be empty.
    */
    settings: Array<CompanyThemeSettingDto>;

    constructor(options?: APIModelOptions) {
        super(CompanyThemeViewDto.attributeTypeMap, options);
    }

    static get attributeTypeMap(): Array<AttributeMapItem> {
        return [
            { name: "id", type: "number" },
            { name: "version", type: "string" },
            { name: "settings", type: "Array<CompanyThemeSettingDto>" }
        ];
    }
}




